import React from 'react';
import FoundHerHero from './modules/foundher/FoundHerHero';
import FoundHerAbout from './modules/foundher/FoundHerAbout';
import FoundHerPartners from './modules/foundher/FoundHerPartners';
import FoundHerEconomy from './modules/foundher/FoundHerEconomy';
import FoundHerOpportunities from './modules/foundher/FoundHerOpportunities';
import FoundHerCTA from './modules/foundher/FoundHerCTA';
import FoundHerFooter from './modules/foundher/FoundHerFooter';

const FoundHer = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white overflow-x-hidden font-sans">
      <FoundHerHero />
      <FoundHerAbout />
      <FoundHerPartners /> 
      <FoundHerEconomy />
      <FoundHerOpportunities />
      <FoundHerCTA />
      <FoundHerFooter />
    </div>
  );
};

export default FoundHer;